import Vue from 'vue'
import axios from 'axios'

export const healthConsentBus = new Vue()

let pendingResolver = null
let pendingUserId = null

const STORAGE_KEY_PREFIX = 'newself_health_consent_accepted'

function consentKey(userId) {
    return userId ? `${STORAGE_KEY_PREFIX}_${userId}` : STORAGE_KEY_PREFIX
}

export function hasAcceptedHealthConsent(userId) {
    try {
        return localStorage.getItem(consentKey(userId)) === '1'
    } catch (e) {
        return false
    }
}

export function requestHealthConsent(userId) {
    if (hasAcceptedHealthConsent(userId)) {
        return Promise.resolve(true)
    }
    return new Promise((resolve) => {
        pendingResolver = resolve
        pendingUserId = userId || null
        healthConsentBus.$emit('show')
    })
}

export function resolveHealthConsent(accepted) {
    if (accepted) {
        try {
            localStorage.setItem(consentKey(pendingUserId), '1')
        } catch (e) { /* ignore storage errors */ }
        const apiBase = process.env.VUE_APP_API_ENDPOINT
        if (apiBase) {
            axios.get(`${apiBase}/api/accept-hippa`).catch(() => {})
        }
    }
    if (pendingResolver) {
        const resolver = pendingResolver
        pendingResolver = null
        resolver(!!accepted)
    }
    pendingUserId = null
    healthConsentBus.$emit('hide')
}
